<div class="loader-container">
    <div class="inner">
        <img src="../../assets/gifs/loading.gif" width="256px" />
    </div>
</div>
